import { useStoreState } from 'easy-peasy';
import { useQuery } from 'react-query';

import { QueryKey } from '@ge/models/constants';
import { Config } from '@ge/shared/data-hooks';
import { fetchAllContracts } from '@ge/shared/services/kpi';

export const useReportContractsData = (templateType) => {
  let allSites = useStoreState((state) => state.sites.sites);

  const params = {
    siteIds: Object.keys(allSites),
  };

  const { data: _data, isLoading } = useQuery(
    [QueryKey.ALL_CONTRACTS],
    () => fetchAllContracts(params),
    {
      ...Config.EXECUTE_ONCE,
      enabled: templateType === 'CONT',
    },
  );

  return {
    isLoading: isLoading,
    data: _data?.data || [],
  };
};
